var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.82,
    height: 66.396,
    viewBox: "0 0 68.82 66.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_122-box-15",
    "data-name": "122-box-15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M241.9,248.745a.977.977,0,0,0-1.57.208l-2.354,4.38a.975.975,0,0,0,.858,1.437,1,1,0,0,0,.877-.514l.537-.968v8.383a.975.975,0,1,0,1.95,0v-9.8l.793.857a.971.971,0,1,0,1.406-1.339Z",
    transform: "translate(-205.98 -216.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M34.975,338.45a.975.975,0,0,0-.975.975v3.611a.975.975,0,0,0,1.95,0v-3.611A.975.975,0,0,0,34.975,338.45Z",
    transform: "translate(-30.517 -293.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M62.975,357.65a.975.975,0,0,0-.975.975v3.253a.975.975,0,0,0,1.95,0v-3.253A.975.975,0,0,0,62.975,357.65Z",
    transform: "translate(-54.617 -310.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M91.975,376.85a.975.975,0,0,0-.975.975v2.864a.975.975,0,1,0,1.95,0v-2.864A.975.975,0,0,0,91.975,376.85Z",
    transform: "translate(-79.577 -326.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M119.975,396.05a.975.975,0,0,0-.975.975V399.5a.975.975,0,1,0,1.95,0v-2.475A.975.975,0,0,0,119.975,396.05Z",
    transform: "translate(-103.676 -343.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M148,418.365a.975.975,0,1,0,1.95,0v-2.14a.975.975,0,1,0-1.95,0Z",
    transform: "translate(-128.636 -359.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M245.7,352.659l-4.443,2.565a.975.975,0,1,0,.975,1.689l4.443-2.565a.975.975,0,1,0-.975-1.689Z",
    transform: "translate(-208.481 -305.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M77.808,68.16c0-.028-.009-.057-.016-.084l-.008-.03q-.012-.043-.028-.085l-.008-.022a.973.973,0,0,0-.049-.1l-3.193-5.844a.861.861,0,0,0-.136-.173,2.78,2.78,0,0,0-2.058-.89H65.978V59.587a2.8,2.8,0,0,0-1.532-2.492V34.118a.979.979,0,0,0-.493-.847L37.21,17.831a.975.975,0,0,0-.975,0L9.505,33.263A.975.975,0,0,0,9,34.118v33.56a.975.975,0,0,0,.488.844L36.235,83.965a.975.975,0,0,0,.488.131,1,1,0,0,0,.488-.152l14.977-8.667h1.14a4.154,4.154,0,0,0,8.076,0h4.974a4.154,4.154,0,0,0,8.076,0h.574a2.76,2.76,0,0,0,2.792-2.751V68.3a.979.979,0,0,0-.007-.113C77.811,68.179,77.81,68.169,77.808,68.16Zm-11.83-5.281h6.334a.83.83,0,0,1,.551.193L75.2,67.337H65.978Zm-2.659-4.146a.865.865,0,0,1,.709.855v7.75H51.072v-7.75a.883.883,0,0,1,.841-.887H63.2A.86.86,0,0,1,63.319,58.732ZM52.2,28.739l-24.8,14.315-4.866-2.81L47.337,25.93ZM26.414,44.716V62.591l-1.838-2.073a1.007,1.007,0,0,0-1.125-.257l-1.913.781V41.933ZM36.723,19.8l8.664,5-24.8,14.316-8.663-5Zm-.975,61.63L10.95,67.115V35.8l8.637,5V62.5a.994.994,0,0,0,1.368.9l2.6-1.071,3.073,3.489a.977.977,0,0,0,.733.331,1.052,1.052,0,0,0,.358-.063.988.988,0,0,0,.645-.912V45.842l7.383,4.279Zm.975-33-7.364-4.251,24.8-14.315,7.363,4.251ZM49.86,74.411,37.7,81.432V50.121L62.5,35.8V56.749H51.913a2.835,2.835,0,0,0-2.792,2.838V72.526a2.775,2.775,0,0,0,.738,1.884Zm7.5,2.137a2.2,2.2,0,1,1,2.205-2.2A2.2,2.2,0,0,1,57.365,76.548Zm13.052,0a2.2,2.2,0,1,1,2.2-2.2,2.2,2.2,0,0,1-2.2,2.2Zm5.453-4.022a.808.808,0,0,1-.841.8h-.574a4.154,4.154,0,0,0-8.077,0H61.4a4.154,4.154,0,0,0-8.077,0H51.913a.808.808,0,0,1-.841-.8V69.287h24.8Z",
    transform: "translate(-9 -17.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox2);
export default __webpack_public_path__ + "static/media/box2.2b20bff6511c198ee9c3bb23302c90e1.svg";
export { ForwardRef as ReactComponent };